import { axiosInstance } from 'services/axiosBaseInstance';

export async function getCategoryList() {
    const response = await axiosInstance.get(`category/dictionary`);
    return response?.data?.values;
}




